/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DeliveryDetail = zod
	.object({
		attempt: zod.number().describe('Attempt number'),
		destination_id: zod.string().describe('Destination ID'),
		duration_ms: zod.number().nullable().describe('Duration in milliseconds'),
		endpoint_url: zod.string().describe('Destination endpoint URL'),
		error_class: zod.string().nullable().describe('Error classification'),
		error_message: zod.string().nullable().describe('Error message'),
		id: zod.string().describe('Delivery attempt ID'),
		occurred_at: zod.iso.datetime({ offset: true }).describe('When the delivery occurred'),
		request_payload: zod.string().nullable().describe('Request payload'),
		response_payload: zod.string().nullable().describe('Response payload'),
		response_status: zod.number().nullable().describe('HTTP response status'),
		response_status_class: zod.number().nullable().describe('HTTP status class (200, 400, 500)'),
		source_event_id: zod.string().describe('Source event ID'),
		source_event_type: zod.string().describe('Source event type'),
		status: zod.string().describe('Delivery status (delivered\/failed)')
	})
	.describe('Individual delivery attempt detail');

export type DeliveryDetail = zod.input<typeof DeliveryDetail>;
export type DeliveryDetailOutput = zod.output<typeof DeliveryDetail>;
